export default __webpack_public_path__ + "static/media/48px_amex 1.33373a79.svg";